// @ts-check
import { Bar, BarChart, Cell, Line, LineChart, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';

// Keyed by status name (backend ReviewStatus) so a colour never shifts when another status is absent.
const COLORS = { pending: '#f59e0b', approved: '#22c55e', rejected: '#ef4444', flagged: '#8b5cf6', deleted: '#64748b' };
const FALLBACK_COLOR = '#94a3b8';

/** Review moderation queue: counts by status (status names come from the API), a received-per-day sparkline, and the oldest pending age. */
export default function ReviewsBlock({ block }) {
  const { pending = 0, by_status: byStatus = {}, received_daily: daily = [], oldest_pending_days: oldest = null } = block.data || {};
  const bars = Object.entries(byStatus).map(([name, value]) => ({ name, value, fill: COLORS[name] || FALLBACK_COLOR }));
  const spark = daily.map((value, i) => ({ i, value }));
  const received = daily.reduce((a, b) => a + b, 0);

  return (
    <BlockCard title="Reviews" href={block.href} headline={block.headline}>
      {bars.length > 0 ? (
        <div data-testid="reviews-chart" className="overflow-x-auto">
          <BarChart width={280} height={110} data={bars} aria-hidden="true">
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={11} />
            <YAxis hide allowDecimals={false} />
            <Bar dataKey="value" isAnimationActive={false}>
              {bars.map((b) => (
                <Cell key={b.name} fill={b.fill} />
              ))}
            </Bar>
          </BarChart>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No reviews yet</p>
      )}
      {received > 0 && (
        <div data-testid="reviews-spark" className="mt-2 overflow-x-auto">
          <LineChart width={280} height={36} data={spark} aria-hidden="true">
            <YAxis hide domain={[0, 'auto']} />
            <Line type="monotone" dataKey="value" stroke="#3b82f6" strokeWidth={2} dot={false} isAnimationActive={false} />
          </LineChart>
        </div>
      )}
      <p className="mt-2 text-sm text-muted-foreground">
        <span data-testid="reviews-received">{received} received in range</span>
        <span data-testid="reviews-oldest" className="ml-2">
          {pending > 0 && oldest !== null ? `Oldest pending ${oldest}d` : 'Nothing pending'}
        </span>
      </p>
    </BlockCard>
  );
}
